import isArray from './is-array';

const isObject = (data: any) => {
  return (
    data === Object(data) &&
    !isArray(data) &&
    typeof data !== 'function' &&
    !(data instanceof Date)
  );
};

export default isObject;
